import React, { useState, useEffect, useRef } from 'react';
import Barcode from 'react-barcode';
import CustomSelect from '../customComponents/CustomSelect';
import styles from '../styles/BarcodePrintModal.module.css';

const BarcodePrintModal = ({ product, onClose }) => {
  const safeProduct = product || {};

  const [labelShape, setLabelShape] = useState('');
  const [labelSize, setLabelSize] = useState('');
  const [oldPrice, setOldPrice] = useState(false);
  const [priceFontSize, setPriceFontSize] = useState(16);
  const [nameFontSize, setNameFontSize] = useState(12);

  const priceRef = useRef(null);
  const nameRef = useRef(null);

  const updateRangeBackground = (input) => {
    if (!input) return;
    const min = Number(input.min);
    const max = Number(input.max);
    const val = Number(input.value);

    const percent = ((val - min) / (max - min)) * 100;

    input.style.background = `linear-gradient(to right, #1D8752 0%, #1D8752 ${percent}%, #ccc ${percent}%, #ccc 100%)`;
  };

  useEffect(() => {
    updateRangeBackground(priceRef.current);
    updateRangeBackground(nameRef.current);
  }, []);

  // Можно подстроить поля под твой бек: тут безопасные варианты
  const currentPrice =
    safeProduct.sell_price ?? safeProduct.purchase_price ?? safeProduct.price ?? 'none';

  const previousPrice =
    safeProduct.old_price ?? safeProduct.previous_price ?? safeProduct.prev_price ?? null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <h2 className={styles.title}>Распечатать штрихкод</h2>

        <div className={styles.content}>
          <div className={styles.left}>
            <div className={styles.headingText}>{safeProduct.name_ru || '—'}</div>
            <div className={styles.headingSubtitle}>
              <p>Категория:</p> <p>{safeProduct.gtin || '—'}</p>
            </div>
            <div className={styles.headingSubtitle}>
              <p>Штрихкод:</p> <p>{safeProduct.ntin || '—'}</p>
            </div>
            <div className={styles.headingSubtitle}>
              <p>Артикул:</p> <p>{safeProduct.article || '—'}</p>
            </div>

            <div className={styles.settings}>
              <CustomSelect
                className={styles.filters__select}
                options={['Прямоугольный', 'Квадратный']}
                value={labelShape}
                onChange={setLabelShape}
                placeholder="Форма этикетки:"
              />

              <div className={styles.box}></div>

              <CustomSelect
                className={styles.filters__select}
                options={['43х25', '56x38']}
                value={labelSize}
                onChange={setLabelSize}
                placeholder="Размер этикетки: "
              />

              <label className={styles.checkboxContainer}>
                <input
                  type="checkbox"
                  checked={oldPrice}
                  onChange={(e) => setOldPrice(e.target.checked)}
                />
                <span className={styles.customCheckbox}></span>
                <span className={styles.checkboxLabel}>Старая цена</span>
              </label>

              <label className={styles.rangeContainer}>
                <p className={styles.textLabel}>Размер цены:</p>
                <div className={styles.rangeWrapper}>
                  <input
                    type="range"
                    min="10"
                    max="24"
                    value={priceFontSize}
                    ref={priceRef}
                    onChange={(e) => {
                      const v = Number(e.target.value);
                      setPriceFontSize(v);
                      updateRangeBackground(e.target);
                    }}
                  />
                  <span className={styles.rangeValue}>{priceFontSize}px</span>
                </div>
              </label>

              <label className={styles.rangeContainer}>
                <p className={styles.textLabel}>Размер названия:</p>
                <div className={styles.rangeWrapper}>
                  <input
                    type="range"
                    min="10"
                    max="24"
                    value={nameFontSize}
                    ref={nameRef}
                    onChange={(e) => {
                      const v = Number(e.target.value);
                      setNameFontSize(v);
                      updateRangeBackground(e.target);
                    }}
                  />
                  <span className={styles.rangeValue}>{nameFontSize}px</span>
                </div>
              </label>
            </div>
          </div>

          <div className={styles.right}>
            <div className={styles.preview}>
              <div className={styles.block}>
                <div
                  className={styles.fontSize}
                  style={{ fontSize: `${nameFontSize}px` }}
                >
                  {safeProduct.name_ru ? `"${safeProduct.name_ru}"` : '—'}
                </div>

                {/* Цена */}
                <div style={{ fontSize: `${priceFontSize}px`, fontWeight: 'bold' }}>
                  {currentPrice} ₸
                </div>

                {/* Старая цена (показываем только если включили чекбокс) */}
                {oldPrice && (
                  <div style={{ marginTop: '4px' }}>
                    {previousPrice ? (
                      <span style={{ textDecoration: 'line-through', opacity: 0.7 }}>
                        {previousPrice} ₸
                      </span>
                    ) : (
                      <span style={{ opacity: 0.7 }}>Старая цена: —</span>
                    )}
                  </div>
                )}

                <div className={styles.barcodeBox}>
                  <Barcode
                    value={safeProduct.ntin || 'none'}
                    height={40}
                    width={1.5}
                    fontSize={12}
                    displayValue={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.footer}>
          <button onClick={onClose} className={styles.cancel}>
            Отмена
          </button>
          <button className={styles.print}>Распечатать</button>
        </div>
      </div>
    </div>
  );
};

export default BarcodePrintModal;
